import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { RegistrationResponse } from "../registration.model";

import { DGA_REGISTRATION_ACTION_TYPE } from "./dga-registration.action";
import { DgaRegistrationState } from "./dga-registration.model";

const INITIAL_STATE: DgaRegistrationState = {
	isBusy: false,
};

export function dgaRegistrationReducer(state = INITIAL_STATE, action: ActionWithPayload): DgaRegistrationState {
	switch (action.type) {
		case DGA_REGISTRATION_ACTION_TYPE.setRegistrationDetails: {
			return updateState(state, {
				registrationFormData: action.payload,
			});
		}
		case DGA_REGISTRATION_ACTION_TYPE.getRegistrationToken: {
			return updateState(state, {
				token: undefined,
				hashedEmail: undefined,
				isBusy: true,
			});
		}
		case DGA_REGISTRATION_ACTION_TYPE.getRegistrationTokenFail: {
			return updateState(state, {
				token: undefined,
				hashedEmail: undefined,
				isBusy: false,
			});
		}
		case DGA_REGISTRATION_ACTION_TYPE.getRegistrationTokenSuccess: {
			const response = action.payload as RegistrationResponse;
			return updateState(state, {
				token: response.token,
				hashedEmail: response.hashedEmail,
				isBusy: false,
			});
		}
		case DGA_REGISTRATION_ACTION_TYPE.resetRegistrationState: {
			return INITIAL_STATE;
		}
		default:
			return state;
	}
}
